export enum CategoryNavView {
  MOBILE = 'MOBILE',
  SMALL = 'SMALL'
}

type ColumnProps = {
  [key: string]: number
}

export type M005Props = {
  /** Written copy that describes the Image */
  altText: string
  /** Optional props for the column */
  columnProps?: ColumnProps
  /** Optional image aspect ratio, defaults to 'MOBILE' */
  categoryNavigationView?: CategoryNavView
  /** Optional text for the CTA, not really a cta */
  ctaCopy?: string
  /** Optional text for heading */
  heading?: string
  /** Optional image scaling, defaults to 'contain' */
  imageZoom?: string
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget?: '' | '_blank' | '_self'
  /** Optional link title, can be seen when hovering over the component */
  linkTitle?: string
  /** Optional link url */
  linkUrl?: string
  /** Optional image */
  mainImage?: string
  /** Optional number of offers to help with scaling the aspect ratio */
  offerSize?: number
  /** Optional text for subheading */
  subheading?: string
  /** Optional grouping logic name */
  consumingGrid?: string
  /** Optional number for total number of offers */
  offersLength?: number
  /** Optional function to handle the CTA click */
  onLinkClick?: (event?: React.MouseEvent<HTMLElement>, url?: string) => void
}
